/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import get from 'lodash/get'

export const selectApp = (state) => state.app
export const selectedHeaderData = (state) => get(state, 'header.headerData')
export const selectedDeviceData = (state) => get(state, 'device')
export const selectUser = (state) => get(state, 'user')
export const selectAuth = (state) => get(state, 'auth', {})
export const selectMessage = (state) => get(state, 'message')
export const selectSchool = (state) => get(state, 'school', {})
export const selectMasterData = (state) => get(state, 'masterData', {})
export const selectMetaData = (state) => get(state, 'metadata', {})
export const selectUiState = (state) => get(state, 'uiState')
export const selectPayment = (state) => get(state, 'payment')
export const selectEnrolledPrograms = (state) => get(state, 'enrolledPrograms')
export const selectPriorPrograms = (state) => get(state, 'priorPrograms')
export const selectSurveys = (state) => get(state, 'surveyData.surveys')
export const selectTransaction = (state) => state.transaction
export const selectIntrospect = (state) => state.introspect
export const selectChildren = (state) => get(state, 'parents')
export const selectCurrentChild = (state) =>
  get(state, 'parents.children').find((item) => item.urn === get(state, 'parents.id')) || {}
export const selectServiceProvider = (state) => get(state, 'serviceProvider')
export const selectEnrollmentSummary = (state) => get(state, 'enrollmentSummary')
